import { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { setActiveComponent } from "../../Reducer/RevenueModuleSlice";
import axios from "axios";
import { roleId } from "../Constants/app";
import { FaCheck } from "react-icons/fa";
import moment from "moment";
import { utils, writeFileXLSX } from "xlsx";

const fields = {
    plannedRevenue: 'Плановая выручка',
    planExecution: 'Выполнение плана (%)',
    revenueYE: 'Выручка ЯЕ/ДК',
    revenueKuper: 'Выручка Купер',
    revenueOnline: 'Выручка ЮКасса',
    revenueCash: 'Наличные в кассе',
    revenueNonCash: 'Безналичные ',
    cashierFIO: 'Кассир (ФИО)',
};

const separators = {
    points: 'Филиалы',
    date: 'Дата'
};

function ReportsRM() {
    const User = useSelector(state => state.UserSlice.User);
    const Server = useSelector(state => state.UserSlice.Server);

    const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const [cities, setCities] = useState([]);
    const [selectedCities, setSelectedCities] = useState([]);
    const [selectedFields, setSelectedFields] = useState([]);
    const [selectedSeparators, setSelectedSeparators] = useState([]);
    const [period, setPeriod] = useState({start: moment().format('YYYY-MM-DD'), end: moment().add('month', 1).format('YYYY-MM-DD')})

    const dispatch = useDispatch();

    const getCity = async () =>  {
        setLoading(true)
        var CityArrayChecked = []
        var CityCheck
        await axios.get(Server + 'cities?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            }
        })
        .then((response) => {
            if([roleId.admin, roleId.operatingDirector].includes(User.user.role.id) || User.user.idCity === 'all')
            {
                setLoading(response.data);
                setCities(response.data);
            }
            else
            {
                CityCheck = response.data
            }
        })

        if(![roleId.admin, roleId.operatingDirector].includes(User.user.role.id) && User.user.idCity !== 'all')
        {
            await User.user.idCity.map((el) => {
                CityCheck.map((a) => {
                    if(parseInt(a.id) === parseInt(el))
                    {
                        CityArrayChecked.push(a)
                    }
                    return(a)
                })
                return(el)
            })
            await setLoading(CityArrayChecked)
            await setCities(CityArrayChecked)
        }
        
        setLoading(false)
    }

    useEffect(() => {
        getCity();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onClose = () => { dispatch(setActiveComponent(null)) }

    const isValidStep = () => {
        if (step === 1 && selectedCities.length > 0) return true;
        if (step === 2 && period.start && period.end) return true;
        return false;
    }

    const getExportData = (data) => {
        const { revenues, totalByDate, totalOverall } = data;
        const result = [];
    
        const getOrderedFields = (dataRow) => {
            const orderedRow = {};
            
            if (dataRow['Дата']) orderedRow['Дата'] = dataRow['Дата'];
            if (dataRow['Филиал']) orderedRow['Филиал'] = dataRow['Филиал'];
            if (dataRow['Период']) orderedRow['Период'] = dataRow['Период'];
            
            if (selectedFields.includes('plannedRevenue') || dataRow['Плановая выручка']) {
                orderedRow['Плановая выручка'] = dataRow['Плановая выручка'] || '';
            }
            
            if (selectedFields.includes('planExecution') || dataRow['Выполнение плана (%)']) {
                orderedRow['Выполнение плана (%)'] = dataRow['Выполнение плана (%)'] || '';
            }
            
            orderedRow['Выручка фактическая общая'] = dataRow['Выручка фактическая общая'] || '';
            
            if (selectedFields.includes('revenueYE') || dataRow['Выручка ЯЕ/ДК']) {
                orderedRow['Выручка ЯЕ/ДК'] = dataRow['Выручка ЯЕ/ДК'] || '';
            }
            
            if (selectedFields.includes('revenueKuper') || dataRow['Выручка Купер']) {
                orderedRow['Выручка Купер'] = dataRow['Выручка Купер'] || '';
            }
            
            if (selectedFields.includes('revenueOnline') || dataRow['Выручка ЮКасса']) {
                orderedRow['Выручка ЮКасса'] = dataRow['Выручка ЮКасса'] || '';
            }
            
            if (selectedFields.includes('revenueCash') || dataRow['Наличные в кассе']) {
                orderedRow['Наличные в кассе'] = dataRow['Наличные в кассе'] || '';
            }
            
            if (selectedFields.includes('revenueNoncash') || dataRow['Безналичные']) {
                orderedRow['Безналичные'] = dataRow['Безналичные'] || '';
            }
            
            if (selectedFields.includes('cashierFIO') || dataRow['Кассир (ФИО)']) {
                orderedRow['Кассир (ФИО)'] = dataRow['Кассир (ФИО)'] || '';
            }
            
            return orderedRow;
        };
    
        const createRow = (data, additionalFields = {}) => {
            const row = {};
            
            Object.entries(additionalFields).forEach(([key, value]) => {
                row[key] = value;
            });
            
            selectedFields.forEach(field => {
                if (fields[field]) {
                    row[fields[field]] = data[field] || data[field] === 0 ? data[field] : '';
                }
            });
            
            row['Выручка фактическая общая'] = data.revenueTotal || data.revenueTotal === 0 ? data.revenueTotal : '';
            
            return getOrderedFields(row);
        };
    
        if (selectedSeparators.includes('points')) {
            revenues.forEach(revenue => {
                const city = cities.find(c => c.id === revenue.idCity);
                const cityName = city ? `${city.City} ${city.Adress}` : `Филиал ${revenue.idCity}`;
                
                if (selectedSeparators.includes('date')) {
                    Object.entries(revenue.daysData[0]).forEach(([date, dayData]) => {
                        result.push(createRow(dayData, {
                            'Дата': date,
                            'Филиал': cityName
                        }));
                    });
                } else {
                    result.push(createRow(revenue.total, {
                        'Филиал': cityName
                    }));
                }
            });
            
            if (result.length > 0) {
                result.push({});
                result.push(createRow(totalOverall, {
                    'Филиал': 'ИТОГО'
                }));
            }
        }
        
        else if (selectedSeparators.includes('date') && !selectedSeparators.includes('points')) {
            Object.entries(totalByDate).forEach(([date, dateData]) => {
                result.push(createRow(dateData, {
                    'Дата': date
                }));
            });
            
            if (result.length > 0) {
                result.push({});
                result.push(createRow(totalOverall, {
                    'Дата': 'ИТОГО'
                }));
            }
        }
        
        else if (selectedSeparators.length === 0) {
            result.push(createRow(totalOverall, {
                'Период': `С ${period.start} по ${period.end}`
            }));
        }
    
        return result;
    };

    const exportData = async () => {
        setLoading(true);
    
        const data = {
            separators: selectedSeparators,
            fields: selectedFields,
            startDate: period.start,
            endDate: period.end,
            points: selectedCities,
        }
    
        try {
            const response = await axios.post(Server + 'revenuereports/getReport', data, {
                headers: {
                    Authorization: 'Bearer ' + User.jwt,
                },
            });
    
            const res = getExportData(response.data);
    
            if(!res || res.length === 0) {
                alert("Данные отсутствуют. Выберите другие фильтры.");
                setLoading(false);
                return;
            }
    
            if(res.length > 0) {            
                const ws = utils.json_to_sheet(res);
                const wb = utils.book_new();
                utils.book_append_sheet(wb, ws, "Отчет по выручке");
                
                const colWidths = [];
                Object.keys(res[0] || {}).forEach(key => {
                    colWidths.push({ wch: Math.max(10, key.length + 2) });
                });
                ws['!cols'] = colWidths;
                
                writeFileXLSX(wb, `отчет_выручка_${moment().format('DD.MM.YYYY')}.xlsx`);
                setLoading(false);
            }
        } catch (error) {
            console.error('Ошибка при экспорте:', error);
            alert('Произошла ошибка при экспорте данных');
            setLoading(false);
        }
    }

    const handleClickNext = () => {
        if (!isValidStep()) {
            const text = step === 1 ? 'Не указаны филиалы' : 'Не указан период';
            alert(text);
            return;
        }
        if(step === 1) return setStep(step + 1);
        return exportData();
    }

    const handleClickBack = () => {
        if (step === 1) return onClose();
        setStep(step - 1);
    }

    const renderHeadTitle = () => {
        if (step === 1) return 'Выбор филиалов';
        return 'Настройки экспорта';
    }

    const addCity = (id) => {
        setSelectedCities(prev => 
            prev.includes(id) 
                ? prev.filter(item => item !== id)
                : [...prev, id]
        );
    }

    const handleChangeCheckbox = (value, type) => {
        if (type === 'fields') {
            setSelectedFields(prev => 
                prev.includes(value) 
                    ? prev.filter(item => item !== value)
                    : [...prev, value]
            );
        } else {
            setSelectedSeparators(prev => 
                prev.includes(value) 
                    ? prev.filter(item => item !== value)
                    : [...prev, value]
            );
        }
    }

    const handleChangeDate = (field, e) => {
        const updated = { ...period };
        updated[field] = moment(e.target.value).format('YYYY-MM-DD');
        if (field === 'start') {
            const endValue = moment(e.target.value).add('month', 1).format('YYYY-MM-DD');
            if (updated.end > endValue) updated.end = endValue;
        }
        setPeriod(updated);
    }

    const renderDateInputs = () => {
        return (
            <div style={{ display: 'flex', gap: '5px' }}>
                <input
                className="ChoicePeriodInput AR"
                id="ChoicePeriodInput Min"
                type="date"
                value={period.start}
                max={period.end}
                onChange={(e) => handleChangeDate('start', e)}
                />
                -                                  
                <input
                className="ChoicePeriodInput AR"
                id="ChoicePeriodInput Max"
                type="date"
                value={period.end}
                min={period.start}
                max={moment(period.start).add('month', 1).format('YYYY-MM-DD')}
                onChange={(e) => handleChangeDate('end', e)}
                />
            </div> 
        );
        
    }

    const renderAdress = (item) => {
        return item.City + ' ' + item.Adress;
    }

    const renderBody = () => {
        if (loading) return(
            <div className="ModalGlobalDiv" >
                <div className="BigSpin" />
            </div>
        )

        if (step === 1) return (
            <div className="AddUserCityContain" style={{ width: '100%' }}>
                {cities.sort((a, b) => {
                const adressA = renderAdress(a);
                const adressB = renderAdress(b);
                if (adressA < adressB) return -1;
                if (adressA > adressB) return 1;
                return 0;
                })
                .map((el) => (
                    <div key={el.id} className="AddUserOneCityMainContain">
                        <div className="AddUserOneCityContain" onClick={() => addCity(el.id)}>
                            <div className={selectedCities.includes(el.id) ? "ChekerEnteringDataAR Active" : "ChekerEnteringDataAR"}>
                                <FaCheck className={selectedCities.includes(el.id) ? "ChekerEnteringDataARIcon Active" : "ChekerEnteringDataARIcon"}/>
                            </div>
                            <div>{renderAdress(el)}</div>
                        </div>
                    </div>
                ))}
            </div>
        );

        return (
            <div className="ModalStaffManagmentDiv">
                <div style={{ fontWeight: 600 }}> Период </div>
                {renderDateInputs()}
                <div style={{ width: '100%', height: '0px', borderTop: '1px solid black'}}></div>
                <div style={{ fontWeight: 600 }}> Поля </div>
                <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap'}}>
                    {Object.entries(fields).map(([key, title]) => (
                        <label key={key} style={{ width: '220px' }}>
                            <input 
                                onChange={() => handleChangeCheckbox(key, 'fields')} 
                                type="checkbox" 
                                checked={selectedFields.includes(key)}
                            />
                            <span>{title}</span>
                        </label>
                    ))}
                </div>
                <div style={{ width: '100%', height: '0px', borderTop: '1px solid black'}}></div>
                <div style={{ fontWeight: 600 }}> Разделения </div>
                <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap'}}>
                    {Object.entries(separators).map(([key, title]) => (
                        <label key={key} style={{ width: '220px' }}>
                            <input 
                                onChange={() => handleChangeCheckbox(key, 'separators')} 
                                type="checkbox" 
                                checked={selectedSeparators.includes(key)}
                            />
                            <span>{title}</span>
                        </label>
                    ))}
                </div>
            </div>
        );
    }

    const renderButton = () => {
        return (
            <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                <button className="ButtonMainMenu" style={{ width: '100px' }} onClick={handleClickBack}>
                    Назад
                </button>
                <button 
                    className="ButtonMainMenu" 
                    style={{ width: '100px' }} 
                    onClick={handleClickNext}
                >
                    {step === 1 ? 'Далее' : 'Экспорт'}
                </button>
            </div>
        );
    }

    return (
        <div className="ModalGlobalDiv">
            <div className="ModalStaffManagmentMainDiv">
                <div className="ModalInformationDiv">
                    <div className="ModalInformationTextDiv">{renderHeadTitle()}</div>
                    <button className="CloseModalIconDiv">
                        <IoClose onClick={onClose} className="CloseModalIcon" />
                    </button>
                </div>
                {renderBody()}
                {renderButton()}
            </div>
        </div>
    );
}

export default ReportsRM;